import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExitToApp from '@material-ui/icons/ExitToApp'
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import StoreIcon from '@material-ui/icons/Store';
import EditIcon from '@material-ui/icons/Edit';
import AssignmentIcon from '@material-ui/icons/Assignment';
import PhotoIcon from '@material-ui/icons/Photo';
import PersonPinIcon from '@material-ui/icons/PersonPinCircle';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import Avatar from '@material-ui/core/Avatar';

import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';

import FileUploader from 'react-firebase-file-uploader';

import _ from "lodash";
import firebase from '../../Firebase';
import AsyncStorage from '@callstack/async-storage';
import Mainmenu from '../../components/mainmenu';

const drawerWidth = 240;

const styles = theme => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.4em'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: '#f2a811',
      borderRadius: '5px',
    }
  },
  hide: {
    display:'none',
  },
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    backgroundColor: '#f2a811',
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  toolbarAvatar: {
    borderRadius: 0,
    width: 170,
    left: 10,
  },
  toolbarIconButton:{
    right:0,
    position:'absolute'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto',
  },
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
  h5: {
    marginBottom: theme.spacing.unit * 2,
  },
  loadingColorPrimary: {
    backgroundColor: '#f2a811',
  },
  loadingBarColorPrimary: {
    backgroundColor: '#b1730d',
  },
  uploadingProgress: {
    color: '#f2a811',
    zIndex: 999,
  },
  uploadingProgressTxt: {
    color: '#f2a811',
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: '#fff',
    width: 170,
    height: 170,
    borderRadius: 0,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing.unit,
  },
  label: {
    '&$cssFocused': {
      color: '#f2a811',
    },
  },
  input: {
    '&:after': {
      borderBottomColor: '#f2a811',
    },
  },
  checkbox: {
    color: '#f2a811',
    '&$checked': {
      color: '#f2a811',
    },
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    color: '#fff',
    backgroundColor: '#f2a811',
    '&:hover': {
      backgroundColor: '#b1730d',
    },
    width: 400
  },
  buttonProgress: {
    color: "#fff",
  },
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#f2a811',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
});

class Config extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      drawer: true,
      config:{},

      editing:false,

      company_markup:"",
      minimum_checkout: "",
      email:"",
      fb_page:"",
      messenger:"",
      mobile:"",

      featuredImageUploading: false,
      featuredImageUploadProgress: -1,

      profileCoverImageUploading: false,
      profileCoverImageUploadProgress: -1,
    }
  }

  componentWillMount(){
    AsyncStorage.getItem("user").then(u => {
      if(u) {
        let t = this;
        let user = JSON.parse(u);

       /* if(!user.roles.includes("admin") && user.roles.includes("seller"))
          this.props.navigation.navigate("Inventory");
*/
        firebase.firestore().collection("config").onSnapshot(function(docs) {
          let config = [];
          docs.forEach(doc => {
            let c = JSON.parse(doc._document.data.toString());
            c.id = doc.id;
            config.push(c);
          });
          t.setState({config:config[0], user:user, company_markup:config[0].company_markup, minimum_checkout:config[0].minimum_checkout, email:config[0].support.email, fb_page:config[0].support.fb_page, messenger:config[0].support.messenger, mobile:config[0].support.mobile });
        });
      } else
        this.props.navigation.navigate('Login');
    });
  }

  async logout(){
    /*try {
      await AsyncStorage.removeItem('user');
      this.props.navigation.navigate('Login');
    } catch (error) {
      console.log(error);
    }*/
  }

  toggleDrawer(){
    this.setState({ drawer:!this.state.drawer });
  }

  toggleSwitch(){
    firebase.firestore().collection("config").doc(this.state.config.id).update({
      shop_status: this.state.config.shop_status == "OPEN" ? "CLOSE" : "OPEN",
    }).then(() => {
    }).catch( error => {
      console.log(error);
    });
  }

  edit(){
    this.setState({editing:true});
    firebase.firestore().collection("config").doc(this.state.config.id).update({
      company_markup: this.state.company_markup,
      minimum_checkout: this.state.minimum_checkout,
      support:{
        email: this.state.email,
        fb_page: this.state.fb_page,
        messenger: this.state.messenger,
        mobile: this.state.mobile,
      },
    }).then(() => {
      this.setState({editing:false});
    }).catch( error => {
      console.log(error);
      this.setState({editing:false});
    });
  }

  goTo(p){
    this.props.navigation.navigate(p);
  }

  render() {
    const { classes } = this.props;
    let config = this.state.config;

    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="absolute"
          className={classNames(classes.appBar, this.state.drawer && classes.appBarShift)}
        >
          <Toolbar disableGutters={!this.state.drawer} className={classes.toolbar}>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={() => this.toggleDrawer()}
              className={classNames(
                classes.menuButton,
                this.state.drawer && classes.menuButtonHidden,
              )}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
            >
              Config
            </Typography>
            <IconButton color="inherit" onClick={() => this.logout()}>
              <ExitToApp />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(classes.drawerPaper, !this.state.drawer && classes.drawerPaperClose),
          }}
          open={this.state.drawer}
        >
          <div className={classes.toolbarIcon}>
            <Avatar src="https://firebasestorage.googleapis.com/v0/b/easysuki-dev.appspot.com/o/assets%2FeasySuki-toolbar.png?alt=media&token=3b713ebc-804c-4e5f-8362-aa5d48f5ff29" className={classes.toolbarAvatar}/>
            <IconButton onClick={() => this.toggleDrawer()} className={classes.toolbarIconButton}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          <Mainmenu navigation={this.props.navigation} active="config" />
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <div className={classes.tableContainer}>
            <Paper className={classes.root}>
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  { _.isEmpty(config) ?
                      <LinearProgress
                        classes={{
                          colorPrimary: classes.loadingColorPrimary,
                          barColorPrimary: classes.loadingBarColorPrimary,
                        }}
                      />
                    :
                      <center>
                        <br/>
                        <label>
                          <label className={classes.uploadingProgressTxt}>{ 'Featured Image' }</label>
                          { this.state.config.featured_image == "" ?
                              <Avatar style={{pointer:'cursor', width:300, height:170, borderRadius:0, backgroundColor:"#f2a811"}}>
                                <PhotoIcon/>
                              </Avatar>
                            :
                              <Avatar src={ this.state.config.featured_image } style={{pointer:'cursor', width:300, height:150, borderRadius:0, backgroundColor:"#f2a811"}}/>
                          }
                          <FileUploader
                            hidden
                            accept="image/*"
                            name="avatar"
                            randomizeFilename
                            storageRef={firebase.storage().ref('/ads')}
                            onUploadStart={() => this.setState({featuredImageUploading:true})}
                            onUploadError={(error) => console.log(error)}
                            onUploadSuccess={(filename) => {
                              firebase.storage().ref("/ads").child(filename).getDownloadURL().then((url) => {
                                firebase.firestore().collection("config").doc(config.id).update({
                                  featured_image: url,
                                }).then(() => {
                                  this.setState({ featuredImageUploadProgress:-1 });
                                }).catch( error => {
                                  console.log(error);
                                });
                              });
                            }}
                            onProgress={(progress) => this.setState({featuredImageUploadProgress:progress})}
                          />
                        </label>
                        <br/>
                        { this.state.featuredImageUploadProgress != -1 &&
                          [
                            <div key={0} style={{ display:"flex-end" }}>
                              <CircularProgress size={20} className={classes.uploadingProgress} />
                              <label key={1} className={classes.uploadingProgressTxt}>{ ' Uploading... '+this.state.featuredImageUploadProgress+' %' }</label>
                            </div>,
                            <br key={1} />
                          ]
                        }
                        <label>
                          <label className={classes.uploadingProgressTxt}>{ 'Cover Profile Image' }</label>
                          { this.state.config.profile_cover == "" ?
                              <Avatar style={{pointer:'cursor', width:300, height:170, borderRadius:0, backgroundColor:"#f2a811"}}>
                                <PhotoIcon/>
                              </Avatar>
                            :
                              <Avatar src={ this.state.config.profile_cover } style={{pointer:'cursor', width:300, height:150, borderRadius:0, backgroundColor:"#f2a811"}}/>
                          }
                          <FileUploader
                            hidden
                            accept="image/*"
                            name="avatar"
                            randomizeFilename
                            storageRef={firebase.storage().ref('/ads')}
                            onUploadStart={() => this.setState({profileCoverImageUploading:true})}
                            onUploadError={(error) => console.log(error)}
                            onUploadSuccess={(filename) => {
                              firebase.storage().ref("/ads").child(filename).getDownloadURL().then((url) => {
                                firebase.firestore().collection("config").doc(config.id).update({
                                  profile_cover: url,
                                }).then(() => {
                                  this.setState({ profileCoverImageUploadProgress:-1 });
                                }).catch( error => {
                                  console.log(error);
                                });
                              });
                            }}
                            onProgress={(progress) => this.setState({profileCoverImageUploadProgress:progress})}
                          />
                        </label>
                        <br/>
                        { this.state.profileCoverImageUploadProgress != -1 &&
                          [
                            <div key={0} style={{ display:"flex-end" }}>
                              <CircularProgress size={20} className={classes.uploadingProgress} />
                              <label key={1} className={classes.uploadingProgressTxt}>{ ' Uploading... '+this.state.profileCoverImageUploadProgress+' %' }</label>
                            </div>,
                            <br key={1} />
                          ]
                        }
                        <div style={{ display:"flex-end" }}>
                          <Switch
                            disableRipple
                            checked={config.shop_status == "OPEN" ? true : false}
                            onChange={() => this.toggleSwitch()}
                            value="checkedA"
                            classes={{
                              switchBase: classes.iOSSwitchBase,
                              bar: classes.iOSBar,
                              icon: classes.iOSIcon,
                              iconChecked: classes.iOSIconChecked,
                              checked: classes.iOSChecked,
                            }}
                          />
                          <label className={classes.uploadingProgressTxt}>{ ' Shop status: '+config.shop_status }</label>
                        </div>
                        <div style={{ alignSelf:"center", width:400 }}>
                          <FormControl margin="normal" required fullWidth>
                            <InputLabel className={classes.label}>Minimum Checkout</InputLabel>
                            <Input id="minimum_checkout" name="minimum_checkout" autoComplete="minimum_checkout" className={classes.input} value={this.state.minimum_checkout}
                              onChange={event => {
                                const { value } = event.target;
                                this.setState({ minimum_checkout: value });
                              }}
                            />
                          </FormControl>
                        </div>
                        <div style={{ alignSelf:"center", width:400 }}>
                          <FormControl margin="normal" required fullWidth>
                            <InputLabel className={classes.label}>Company Markup</InputLabel>
                            <Input id="company_markup" name="company_markup" autoComplete="company_markup" className={classes.input} value={this.state.company_markup}
                              onChange={event => {
                                const { value } = event.target;
                                this.setState({ company_markup: value });
                              }}
                            />
                          </FormControl>
                        </div>
                        <div style={{ alignSelf:"center", width:400 }}>
                          <FormControl margin="normal" required fullWidth>
                            <InputLabel className={classes.label}>Email</InputLabel>
                            <Input id="email" name="email" autoComplete="email" className={classes.input} value={this.state.email}
                              onChange={event => {
                                const { value } = event.target;
                                this.setState({ email: value });
                              }}
                            />
                          </FormControl>
                        </div>
                        <div style={{ alignSelf:"center", width:400 }}>
                          <FormControl margin="normal" required fullWidth>
                            <InputLabel className={classes.label}>Facebook Page</InputLabel>
                            <Input id="fb_page" name="fb_page" autoComplete="fb_page" className={classes.input} value={this.state.fb_page}
                              onChange={event => {
                                const { value } = event.target;
                                this.setState({ fb_page: value });
                              }}
                            />
                          </FormControl>
                        </div>
                        <div style={{ alignSelf:"center", width:400 }}>
                          <FormControl margin="normal" required fullWidth>
                            <InputLabel className={classes.label}>Messenger</InputLabel>
                            <Input id="messenger" name="messenger" autoComplete="messenger" className={classes.input} value={this.state.messenger}
                              onChange={event => {
                                const { value } = event.target;
                                this.setState({ messenger: value });
                              }}
                            />
                          </FormControl>
                        </div>
                        <div style={{ alignSelf:"center", width:400 }}>
                          <FormControl margin="normal" required fullWidth>
                            <InputLabel className={classes.label}>Mobile</InputLabel>
                            <Input className={classes.input} value={this.state.mobile}
                              onChange={event => {
                                const { value } = event.target;
                                this.setState({ mobile: value });
                              }}
                            />
                          </FormControl>
                        </div>
                        <Button
                          fullWidth
                          variant="contained"
                          className={classes.button}
                          onClick={() => { this.edit(); }}
                        >
                          { this.state.editing ?
                              <CircularProgress size={24} className={classes.buttonProgress} />
                            :
                              "Edit"
                          }
                        </Button>
                        <br/><br/>
                      </center>
                  }
                </Grid>
              </Grid>
            </Paper>
          </div>
        </main>
      </div>
    );
  }
}

Config.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Config);